import { createAction } from "@reduxjs/toolkit";
import type { UpdateRolesBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export interface UpdateRolesParams {
  userId: string;
  body: UpdateRolesBody;
}

export const updateRoles = createApiThunk<string, UpdateRolesParams>(
  "admin/users/updateRoles",
  async ({ userId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateRoles(userId, body);
    return userId;
  },
);

export const resetUpdateRoles = createAction("admin/users/resetUpdateRoles");
